import React, { useEffect } from 'react';
import { Link, matchPath, NavLink, useLocation } from 'react-router-dom';

import { ChipsItem, EmptyStateView, Icon, Label } from '@atlas/ui';

import history from 'components/MainRouter/history';

import ModalPortal from '../../common/ModalPortal/ModalPortal';
import { defaultRoutes } from '../MainRouter/constants';

import VirtualGameItem from './VirtualGameItem';

const { menu } = defaultRoutes;

const VirtualGameModal = ({ name, subpages }) => {
  const { pathname } = useLocation();

  const gameName = pathname.split('/')[2];

  useEffect(() => {
    if (subpages.length) {
      history.push(subpages[0].location);
    }
  }, []);

  return (
    <ModalPortal backdropOff className="profile-min-z-index">
      <div className="profile-wrapper-absolute virtual-game">
        <Link className="back-to-container" to={menu}>
          <Icon className="icon-back" name="back" />
          <Label className="title-text" message={name} />
        </Link>

        <div className="chips-list">
          {subpages?.map(item => {
            const { id, location, name } = item;
            return (
              <NavLink key={id} to={location}>
                <ChipsItem
                  active={matchPath(pathname, {
                    exact: true,
                    path: location,
                    strict: true,
                  })}
                  label={name}
                />
              </NavLink>
            );
          })}
        </div>
        {gameName ? (
          <VirtualGameItem />
        ) : (
          <EmptyStateView className="absolute" title="please check the game" />
        )}
      </div>
    </ModalPortal>
  );
};

export default VirtualGameModal;
